module.exports = __webpack_public_path__ + "img/logo.3d795774.png";